import { render, staticRenderFns } from "./xiangguanxing.vue?vue&type=template&id=c69b706e&"
import script from "./xiangguanxing.vue?vue&type=script&lang=ts&"
export * from "./xiangguanxing.vue?vue&type=script&lang=ts&"
import style0 from "./xiangguanxing.vue?vue&type=style&index=0&id=c69b706e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports